import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const SectionWrapper = styled("div")(({ theme }) => ({
  paddingTop: "25px",
  paddingBottom: "25px",
  justifyContent: "center",
  width: "100%",
  wordWrap: "break-word",
  display: "flex",
  alignItems: "center",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "'Montserrat', sans-serif",
  fontSize: 15,
  fontWeight: 500,
  width: "100%",
  wordBreak: "break-word",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
  },
}));
